module.exports = __webpack_public_path__ + "static/media/20_galeria_plantillas_combo_simple_rec_15.36cda9a8.png";